export const AUTH_USER = "authUser";

export const TOKEN = "token";
export const ROLE = "role";
export const USER_ID = "user_id";
export const PERMISSION = "permission";
export const ORGANIZATION_ID = "organization_id";
export const WORKSPACE_ID = "workspace_id";
